import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { GalaxyConfirmationModalModule } from '@vendasta/galaxy/confirmation-modal';
import { TranslationModule } from '@galaxy/crm/static';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

interface DialogData {
  date: Date;
}

@Component({
  selector: 'orders-invalid-billing-terms-dialog',
  standalone: true,
  imports: [
    CommonModule,
    GalaxyConfirmationModalModule,
    TranslationModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
  ],
  templateUrl: './invalid-billing-terms-dialog.component.html',
  styleUrl: './invalid-billing-terms-dialog.component.scss',
})
export class InvalidBillingTermsDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public config: DialogData) {}
}
